// export const DEFAULT_REDIRECT = '/'
export const WELCOME_SCREEN = '/witaj'
export const LOGIN_SCREEN = '/zaloguj'
export const MAIN_SCREEN = '/trening'
export const SELECT_PLAN_SCREEN = '/wybierz-plan/:planName'
export const ABOUT_YOU = '/o-tobie'
export const NEW_TRENNING = '/nowy-trening'
export const APP_VERSION = '/wersja-aplikacji'
export const VIDEO = '/video/:videoId'
export const TRENNING_PLAN = '/plan-treningowy'
export const PROGRESS = '/postepy'
export const PROGRESS_ENTRY = '/postepy/wpisy/:entryDate'
export const COMPARE_ENTRY = '/postepy/porownaj/:currentId-:earliestId'
export const MOBILE_FOLDER = '/foldery/:folderName'
export const LIVE_SCREEN = '/live'
export const CACLCULATOR = '/kalkulator'
export const WATER_REMINDER = '/picie-wody'
export const SPLASH_SCREEN = '/redirect'
export const ACCEPT_PAYMENT = '/platnosc-zaakceptowana'
export const CANCEL_PAYMENT = '/platnosc-anulowana'
export const CHOOSE_DIET_SCREEN = '/dieta/wybierz-diete'
export const DIET_MAIN_SCREEN = '/dieta'
export const FILTER_MEALS_SCREEN = '/dieta/:chosenDate/filtruj-posilki'
export const MEAL_DETAILS_SCREEN =
  '/dieta/szczegoly-posilku/:chosenDate/:mealId/:mealName'
export const MEALS_SCREEN = '/dieta/:mealType/:chosenDate/gotowe-posilki'
export const SHOPPING_LIST_SCREEN = '/dieta/:chosenDate/lista-zakupow'
export const USER_PROFILE = '/twoj-profil'
export const CHATBOX = '/chatbox'
export const ALBUM = '/album/:albumId'
export const TEST_NOTIFICATIONS = '/test-notifications'
export const NEW_PROGRESS = '/new_postepy'
export const TEST_NEW_ENTRY = '/new_postepy/wpisy/:entryDate'
export const CONFERENCES_SCREEN = '/treningi-wspolne'
export const CONFERENCES_SINGLE_ROOM = '/treningi-wspolne/pokoj/:roomId'
export const LANDING_PAGE = "/"
export const CHOOSE_MIAZGA_VERSION = "/wybierz-wersje"
export const CHALLENGES_MAIN_PAGE = "/wyzwania/"
export const CHALLENGES_ALBUM_PAGE = "/wyzwania/:folderName"
export const CHALLENGE_PURCHASE = "/wyzwania/kup-pakiet"
